import { render, staticRenderFns } from "./ContentTagsDlg.vue?vue&type=template&id=7117487f&scoped=true"
import script from "./ContentTagsDlg.ts?vue&type=script&lang=ts&external"
export * from "./ContentTagsDlg.ts?vue&type=script&lang=ts&external"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7117487f",
  null
  
)

export default component.exports